// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import Edit from "@insite/mobius/Icons/Edit";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

currentShippingAddressStyles.gridContainer = {
    gap: 0,
    css: css`
        margin-top: 20px;
    `,
};

currentShippingAddressStyles.addressFormModal = {
    sizeVariant: "small",
};

currentShippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: baseline;
    `,
};

currentShippingAddressStyles.headingText = { variant: "h4" };

currentShippingAddressStyles.useBillingAddress = {
    button: {
        color: "primary",
        css: css`
            margin-top: 20px;
        `,
    },
};

currentShippingAddressStyles.editLink = {
    ...createLinkIconStyles({
        icon: Edit,
        linkStyles: {
            css: css`
                margin-left: 30px;
                margin-top: 6px;
                white-space: nowrap;
            `,
        },
    }),
};
